import mutation from './mutation'
import action from './action'
import getter from './getter'
export default {
  namespaced: true,
  state: {
    status: {
      role: ''
    },
    statusState: false,
    internal_users: [],
    internal_user: {
      id: '',
      fullname: '',
      email: '',
      phone: '',
      gender: '',
      alamat: '',
      npwp: '',
      role: ''
    },
    ready: false
  },
  getters: getter,
  mutations: mutation,
  actions: action,
  modules: {}
}
